import { Form, Row, Col, Badge, Button, InputGroup } from 'react-bootstrap';
import icSearch from './assets/img/ic-magnifier.svg';

const CityFilter = ({ 
    searchQuery,
    setSearchQuery, 
}) => {
    
    return (
        <>
            {/* Filter Inputs */}
            <div className="filter">
                <div>
                    <div className="flex-grow-1">
                        <Row>
                            {/* Search by City Name */}
                            <Col md={4}>
                                <Form.Group controlId="searchCity">
                                    <Form.Label>Search</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <InputGroup.Text>
                                            <img src={icSearch} alt="Search" />
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* Applied Filters Display */}
                {searchQuery && (
                    <Row className="filter-results">
                        <Col className="d-flex align-items-center">
                            
                                <Badge bg="info" className="me-2">
                                    City: {searchQuery} 
                                    <Button 
                                        variant="link" size="sm" className="sm"
                                        onClick={() => setSearchQuery('')}
                                    >
                                        ×
                                    </Button>
                                </Badge>
                        </Col>
                    </Row>
                )}
            </div>
        </>
    );
};

export default CityFilter;